import { render, staticRenderFns } from "./affordHeader.vue?vue&type=template&id=a4439732&"
import script from "./affordHeader.vue?vue&type=script&lang=js&"
export * from "./affordHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports